export default __webpack_public_path__ + "static/media/pull-tab.2eb26352.svg";